import { render } from "./GSSundayB.vue?vue&type=template&id=9194cda0&scoped=true"
import script from "./GSSundayB.vue?vue&type=script&scoped=true&lang=js"
export * from "./GSSundayB.vue?vue&type=script&scoped=true&lang=js"

import "./GSSundayB.vue?vue&type=style&index=0&id=9194cda0&scoped=true&lang=css"

import exportComponent from "C:\\Users\\jgurl\\KontraWebsite\\KontraSports\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9194cda0"]])

export default __exports__